/* Bundle product layout (pdg-*): gallery arrows, offer colour swatches, countdown, feature slider.
   Cart add, price spans and the dots/scroll sync come from saint.js (data-product / data-promo). */
(() => {
  if (window.__pdg) return;
  window.__pdg = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const money = (cents) => (window.Saint && window.Saint.formatMoney)
    ? window.Saint.formatMoney(cents)
    : (Number(cents) / 100).toFixed(2);

  /* ---------- Product ---------- */
  function initProduct(section) {
    const wrap = $('[data-product]', section);
    if (!wrap || wrap.dataset.pdgReady) return;
    wrap.dataset.pdgReady = '1';

    const jsonEl = $('[data-product-json]', wrap);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('[data-product-form]', wrap);
    const idInput = form && $('input[name="id"]', form);
    const addBtn = form && $('[data-add-button]', form);
    const addLabel = addBtn && $('[data-add-label]', addBtn);
    const track = $('[data-main-track]', wrap);
    const offer = $('[data-pdg-offer]', wrap);
    /* Variants of the other models offered as the free watch (prices only) */
    const catalogEl = $('[data-pdg-catalog]', wrap);
    let catalog = [];
    try { catalog = catalogEl ? JSON.parse(catalogEl.textContent) : []; } catch (e) { catalog = []; }
    const variantOf = (id) => product && (
      product.variants.find((v) => String(v.id) === String(id))
      || catalog.find((v) => String(v.id) === String(id))
    );

    /* Gallery arrows */
    const go = (dir) => {
      if (!track) return;
      const w = track.clientWidth;
      const max = track.scrollWidth - w;
      let left = Math.round(track.scrollLeft / w) * w + dir * w;
      if (left < 0) left = max;
      if (left > max + 2) left = 0;
      track.scrollTo({ left, behavior: 'smooth' });
    };
    const prev = $('[data-pdg-prev]', wrap);
    const next = $('[data-pdg-next]', wrap);
    prev && prev.addEventListener('click', () => go(-1));
    next && next.addEventListener('click', () => go(1));

    if (!offer || !product) return;

    const selectedOption = () => $$('[data-pdg-option]', offer).find((o) => $('input[type="radio"]', o).checked);

    /* Prices of each option, from the chosen watches (compare-at price when set) */
    function updatePrices() {
      $$('[data-pdg-option]', offer).forEach((option) => {
        const count = Number(option.dataset.count) || 1;
        const free = Number(option.dataset.free) || 0;
        let ids = $$('[data-promo-slot]', option).map((s) => s.value);
        if (!ids.length || ids.length < count) {
          const base = ids[0] || (idInput && idInput.value);
          ids = Array.from({ length: count }, (_, i) => ids[i] || base);
        }
        const variants = ids.map(variantOf).filter(Boolean);
        if (!variants.length) return;
        const prices = variants.map((v) => v.price).sort((a, b) => a - b);
        const pay = prices.slice(free).reduce((a, b) => a + b, 0);
        const compare = variants.reduce((a, v) => a + Math.max(v.compare_at_price || 0, v.price), 0);
        const payEl = $('[data-pdg-pay]', option);
        const cmpEl = $('[data-pdg-compare]', option);
        const saveEl = $('[data-pdg-save]', option);
        if (payEl) payEl.textContent = money(pay);
        if (cmpEl) { cmpEl.textContent = money(compare); cmpEl.hidden = compare <= pay; }
        if (saveEl) saveEl.textContent = money(compare - pay);
      });
    }

    /* The first watch of the selected option drives the form, price, photo and stock */
    function syncMain() {
      const option = selectedOption();
      const first = option && $('[data-promo-slot]', option);
      const variant = first ? variantOf(first.value) : variantOf(idInput && idInput.value);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      const priceWrap = $('[data-price]', wrap);
      if (priceWrap) {
        const cur = $('[data-price-current]', priceWrap);
        const cmp = $('[data-price-compare]', priceWrap);
        if (cur) cur.textContent = money(variant.price);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? money(variant.compare_at_price) : ''; }
      }
      const inst = $('[data-pdg-installments]', wrap);
      if (inst) {
        const n = Number(inst.dataset.pdgInstallments) || 1;
        const el = $('[data-pdg-installment]', inst);
        if (el) el.textContent = money(Math.round(variant.price / n));
      }
      if (addBtn) {
        const ids = $$('[data-promo-slot]', option || offer).map((s) => s.value);
        const allAvailable = (ids.length ? ids : [variant.id]).every((id) => (variantOf(id) || {}).available);
        addBtn.disabled = !allAvailable;
        const s = (window.Saint && window.Saint.strings) || {};
        if (addLabel) addLabel.textContent = allAvailable ? (offer.dataset.addLabel || s.addToCart || 'Add to cart') : (s.soldOut || 'Sold out');
      }
      if (variant.featured_media && track) {
        const slide = $(`[data-main-slide="${variant.featured_media.id}"]`, track);
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    /* Colour swatches above the offer: the first watch of every card follows */
    wrap.addEventListener('click', (e) => {
      const sw = e.target.closest('[data-pdg-main-swatch]');
      if (!sw || sw.disabled) return;
      e.preventDefault();
      const id = sw.dataset.pdgMainSwatch;
      $$('[data-pdg-option]', offer).forEach((option) => {
        const first = $('[data-promo-slot]', option);
        if (first && Array.from(first.options).some((o) => o.value === id)) first.value = id;
      });
      $$('[data-pdg-main-swatch]', wrap).forEach((b) => b.classList.toggle('is-active', b === sw));
      const label = $('[data-pdg-color-name]', wrap);
      if (label) label.textContent = sw.dataset.title || '';
      offer.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Free watch pop-up: moved to <body> so it covers the page */
    const modal = $('[data-pdg-modal]', offer);
    const second = $('[data-pdg-second]', offer);
    if (modal && second) {
      document.body.appendChild(modal);
      const search = $('[data-pdg-modal-search]', modal);
      const cards = $$('[data-pdg-choose]', modal);
      const setOpen = (open) => {
        modal.hidden = !open;
        document.documentElement.classList.toggle('pdg-modal-open', open);
        if (open && search) { search.value = ''; filter(''); setTimeout(() => search.focus({ preventScroll: true }), 0); }
      };
      const filter = (q) => {
        const term = q.trim().toLowerCase();
        cards.forEach((c) => { c.hidden = !!term && !(c.dataset.search || '').includes(term); });
      };
      search && search.addEventListener('input', () => filter(search.value));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) setOpen(false); });
      modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-pdg-modal-close]')) { setOpen(false); return; }
        const card = e.target.closest('[data-pdg-choose]');
        if (!card || card.disabled) return;
        $('[data-promo-slot]', second).value = card.dataset.pdgChoose;
        cards.forEach((c) => c.classList.toggle('is-active', c === card));
        const name = $('[data-pdg-second-name]', second);
        if (name && card.dataset.name) name.textContent = card.dataset.name;
        const thumb = $('[data-pdg-second-thumb]', second);
        if (thumb && card.dataset.img) {
          let img = $('img', thumb);
          if (!img) { img = document.createElement('img'); img.width = 56; img.height = 56; img.alt = ''; thumb.appendChild(img); }
          img.removeAttribute('srcset');
          img.src = card.dataset.img;
        }
        const radio = $('input[type="radio"]', second.closest('[data-pdg-option]'));
        if (radio) radio.checked = true;
        setOpen(false);
        offer.dispatchEvent(new Event('change', { bubbles: true }));
      });
      offer.addEventListener('click', (e) => {
        const open = e.target.closest('[data-pdg-second-open]');
        if (!open) return;
        e.preventDefault();
        setOpen(true);
      });
    }

    /* Colour swatches of a plain extra watch (no free-watch collection) */
    offer.addEventListener('click', (e) => {
      const swatch = e.target.closest('[data-pdg-swatch]');
      if (!swatch) return;
      e.preventDefault();
      if (swatch.disabled) return;
      const pick = swatch.closest('[data-pdg-pick]');
      $('[data-promo-slot]', pick).value = swatch.dataset.pdgSwatch;
      $$('[data-pdg-swatch]', pick).forEach((b) => b.classList.toggle('is-active', b === swatch));
      const radio = $('input[type="radio"]', swatch.closest('[data-pdg-option]'));
      if (radio && !radio.checked) radio.checked = true;
      offer.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* saint.js listens to the same change event; run after it so our labels win */
    offer.addEventListener('change', () => setTimeout(() => { updatePrices(); syncMain(); }, 0));
    updatePrices();
    syncMain();
  }

  /* ---------- Countdown to midnight (visitor's time zone) ---------- */
  function initCountdown(root) {
    $$('[data-pdg-countdown-value]', root).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const s = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = `${pad(Math.floor(s / 3600))} : ${pad(Math.floor(s / 60) % 60)} : ${pad(s % 60)}`;
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Feature slider ---------- */
  function initFeatures(root) {
    $$('[data-pdg-features]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const track = $('[data-pdg-features-track]', wrap);
      const slides = $$('[data-pdg-feature]', wrap);
      const bars = $$('[data-pdg-bar]', wrap);
      const count = $('[data-pdg-count]', wrap);
      if (!track || !slides.length) return;
      const pad = (n) => String(n).padStart(2, '0');
      const current = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0;
        let min = Infinity;
        slides.forEach((s, i) => {
          const d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - center);
          if (d < min) { min = d; best = i; }
        });
        return best;
      };
      const show = (i) => {
        const s = slides[(i + slides.length) % slides.length];
        track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
      };
      const update = () => {
        const i = current();
        bars.forEach((b, j) => b.classList.toggle('is-active', j === i));
        if (count) count.textContent = `${pad(i + 1)} / ${pad(slides.length)}`;
      };
      $('[data-pdg-features-prev]', wrap)?.addEventListener('click', () => show(current() - 1));
      $('[data-pdg-features-next]', wrap)?.addEventListener('click', () => show(current() + 1));
      bars.forEach((b, j) => b.addEventListener('click', () => show(j)));
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- Videos: play only while visible ---------- */
  function initVideos(root) {
    const videos = $$('[data-pdg-video]', root);
    if (!videos.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause();
      });
    }, { threshold: 0.2 });
    videos.forEach((v) => io.observe(v));
  }

  function init(root = document) {
    $$('.pdg', root).forEach(initProduct);
    if (root.classList && root.classList.contains('pdg')) initProduct(root);
    initCountdown(root);
    initFeatures(root);
    initVideos(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
